// extracted by mini-css-extract-plugin
export default {"doctorPic":"topRated_doctorPic__cdtQd","doctorCard":"topRated_doctorCard__56FXr"};